export default "__VITE_ASSET__CJcIPow0__"